import React from 'react';

export const  RefinePresentationSkeleton=()=> {
  return (
    <div className="relative flex flex-col items-center justify-start min-h-screen animate-pulse px-3 pt-4">
      
      <div className="flex items-center justify-between w-full mb-6">
        <div className="h-5 w-24 bg-gray-300 rounded" />
        <div className="flex items-center gap-2">
          <div className="h-5 w-5 bg-gray-300 rounded-full" />
          <div className="h-5 w-16 bg-gray-300 rounded" />
        </div>
      </div>

      
      <div className="w-full mb-4">
        <div className="flex flex-col border-2 bg-gray-100 border-gray-300 rounded-md p-4 gap-4">
          <div className="flex justify-between">
            <div className="h-5 w-32 bg-gray-300 rounded" />
            <div className="h-8 w-8 bg-gray-300 rounded" />
          </div>
          <div className="flex justify-between">
            <div className="h-5 w-40 bg-gray-300 rounded" />
            <div className="h-8 w-8 bg-gray-300 rounded" />
          </div>
        </div>
      </div>

  
      <div className="w-full mb-4">
        <div className="flex flex-col border-2 bg-gray-100 border-gray-300 rounded-md p-4 gap-4 min-h-40">
          <div className="h-5 w-40 bg-gray-300 rounded" />
          <div className="flex gap-4 w-full">
            <div className="flex-1 h-16 bg-gray-300 rounded" />
            <div className="flex-1 h-16 bg-gray-300 rounded" />
          </div>
        </div>
      </div>

     
      <div className="w-full mb-4">
        <div className="flex flex-col border-2 bg-gray-100 border-gray-300 rounded-md p-4 gap-4 min-h-40">
          <div className="h-5 w-32 bg-gray-300 rounded" />
          <div className="flex gap-4 w-full">
            <div className="flex-1 h-16 bg-gray-300 rounded" />
            <div className="flex-1 h-16 bg-gray-300 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}
